import { environmentVariables } from './environmentVariables'
import { redirectToUrl } from './location'

export const onUnauthenticated = (): void => {
  if (typeof window.UIBridge?.onClose === 'function') {
    window.UIBridge.onClose()
  } else {
    redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin`)
  }
}
